/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1086
 */

var r = {}
r[require(/* 246 */"../1782/246/index")("toStringTag")] = "z"
module.exports = "[object z]" === String(r)
